import React from 'react';
import { Alert, Label } from 'reactstrap';
import { FieldArray } from 'formik';
import AddButton from '~/components/addButton/addButton';
import FormikInputField from '~/components/formikInputField/formikInputField';
import FormLayout from '~/components/formLayout/formLayout';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import IconTooltip from '~/components/iconTooltip/iconTooltip';
import ProductOptions from '~/containers/productOptions/productOptions';
import { renderError, hasError } from '~/utils/formikValidation';
import styles from './styles.css';

const OrderForm = ({ values, errors, touched, handleSubmit, isSubmitting }) => {
  console.log(errors);
  const { orderLines } = values;
  return (
    <form onSubmit={handleSubmit}>
      {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
      <FormLayout title="Order details">
        <div className="mb3">
          <Label>Reference (optional)</Label>
          <FormikInputField name="reference" />
        </div>
        <div className="mb3">
          <Label>Delivery date</Label>
          <FormikInputField type="date" name="deliveryDate" invalid={!!errors.deliveryDate} />
          {errors.deliveryDate && <p className="error">{errors.deliveryDate}</p>}
        </div>
      </FormLayout>
      <FormLayout className="mt4" title="Order lines">
        <div className="mb3">
          <FieldArray
            name="orderLines"
            validateOnChange={false}
            render={arrayHelpers => (
              <div>
                {orderLines.map((orderLine, idx) => {
                  return (
                    <div key={idx} className={styles.step}>
                      <div className="flex justify-end">
                        {orderLines.length > 1 && (
                          <div className="flex">
                            <IconTooltip
                              icon="delete-circle"
                              text="Remove order line"
                              className="ml3 stroke-brand-red"
                              onClick={() => arrayHelpers.remove(idx)}
                            />
                          </div>
                        )}
                      </div>
                      <div className="mh3">
                        <div className="flex">
                          <div className="mb3 flex-grow-1">
                            <Label>Product</Label>
                            <FormikInputField
                              type="select"
                              name={`orderLines.${idx}.productId`}
                              invalid={hasError(errors, idx, 'orderLines', 'productId')}
                            >
                              <ProductOptions />
                            </FormikInputField>
                            {renderError(errors, idx, 'products', 'productId')}
                          </div>
                          <div className="mb3 mh2 flex flex-column">
                            <Label>&nbsp;</Label>
                            <p className={`flex-grow-1 ma0 ${styles.mathSymbol}`}>x</p>
                          </div>
                          <div className="mb3 w4">
                            <Label>Quantity</Label>
                            <FormikInputField
                              step="1"
                              type="number"
                              name={`orderLines.${idx}.quantity`}
                              invalid={hasError(errors, idx, 'orderLines', 'quantity')}
                            />
                            {renderError(errors, idx, 'products', 'quantity')}
                          </div>
                          <div className="mb3 mh2 flex flex-column">
                            <Label>&nbsp;</Label>
                            <p className={`flex-grow-1 ma0 ${styles.mathSymbol}`}>=</p>
                          </div>
                          <div className="mb3 w4">
                            <Label>Total</Label>
                            <FormikInputField
                              step=".01"
                              type="number"
                              name={`orderLines.${idx}.total`}
                              invalid={hasError(errors, idx, 'orderLines', 'total')}
                            />
                            {renderError(errors, idx, 'products', 'total')}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div className="tr">
                  <AddButton
                    color="primary"
                    onClick={() =>
                      arrayHelpers.push({
                        orderLines: [
                          {
                            quantity: 0
                          }
                        ]
                      })
                    }
                  >
                    Add another order line
                  </AddButton>
                </div>
              </div>
            )}
          />
        </div>
      </FormLayout>
      <div className="flex justify-end mt4">
        <SubmissionButton color="primary" type="submit" isSubmitting={isSubmitting}>
          Create
        </SubmissionButton>
      </div>
    </form>
  );
};

export default OrderForm;



// WEBPACK FOOTER //
// ./src/components/orderForm/orderForm.jsx